// ============================================================================
//  COACH CONFIGURATION — the single source of truth for all brand copy.
// ============================================================================

export const coach = {
  firstName: "Sophie",
  lastName: "Herriot",
  fullName: "Sophie Herriot",
  businessName: "Sophie Herriot Coaching",
  logoTop: "SOPHIE HERRIOT",
  logoBottom: "COACHING",

  tagline: "Online fitness coaching",
  email: "herriotsophie@gmail.com",

  // Sophie's supplied photography
  images: {
    hero: "/coach/sophie-hero.jpg",            // medal / podium photo
    about: "/coach/sophie-gym.jpg",            // black gym walk photo
    aboutSecondary: "/coach/sophie-athlete.jpg", // red Wisconsin athlete photo
    whatYouGet: "/coach/sophie-fitness.jpg",   // brown fitness mirror photo
    band: "/coach/sophie-pole-vault.jpg",      // pole-vault action photo
  },

  hero: {
    badge: "Now Accepting Clients",
    // Kinetic headline — each string is one masked line
    headline: ["BUILD A BODY", "THAT LOOKS", "AND PERFORMS", "ITS BEST."],
    sub: "1-on-1 online coaching built around your goals, your lifestyle and your body. Personalized training, realistic nutrition and the accountability to keep you progressing.",
    primaryCta: "Apply for Coaching",
    secondaryCta: "My Story",
  },

  // First-person story — athletic background, no fabricated transformation
  about: {
    kicker: "The Story",
    heading: "BUILT THROUGH DISCIPLINE.",
    paragraphs: [
      "Training has always been about more than how I look. As a competitive athlete, I learned early that real progress comes from structure, patience and showing up long after the motivation fades.",
      "Years of training taught me how much the right program, nutrition and attention to detail can change not just how you perform, but how you feel in your own body.",
      "Most people don't need to train like a full-time athlete. They need a plan that actually fits their life.",
      "That's what I want coaching to be — clear training, realistic nutrition, honest accountability and a strategy built around you instead of forcing you into someone else's routine.",
      "My goal is simple: help you become stronger, more confident and more capable, with results you can actually maintain.",
    ],
    signature: "— Sophie Herriot",
    imageLabel: "Sophie Herriot",
    imageTag: "Athlete · Coach",
    secondaryCaption: "From competition to coaching",
  },

  // Credibility / philosophy section (replaces fabricated testimonials)
  approach: {
    kicker: "The Approach",
    heading: "TRAIN WITH PURPOSE.",
    sub: "No guesswork and no cookie-cutter plans — just a strategy built around you and the accountability to see it through.",
    items: [
      { icon: "Target", title: "Smart Training", desc: "Every exercise, set and progression has a reason behind it — structured around your body, your experience and your goals." },
      { icon: "Salad", title: "Realistic Nutrition", desc: "Build a nutrition approach around your lifestyle and the foods you enjoy, instead of forcing your life to fit a diet." },
      { icon: "Repeat", title: "Consistent Accountability", desc: "Progress comes from doing the right things consistently — with someone in your corner keeping the plan moving forward." },
    ],
  },

  whatYouGet: {
    kicker: "The System",
    heading: "WHAT YOU GET",
    sub: "Everything you need to stop guessing and start progressing — nothing you don't.",
    features: [
      { icon: "Dumbbell", title: "Custom Training", desc: "A program built around your goals, experience, schedule and available equipment — then progressed as you get stronger." },
      { icon: "Utensils", title: "Personalized Nutrition", desc: "A realistic strategy built around foods you actually enjoy while keeping you moving toward your goals." },
      { icon: "CalendarCheck", title: "Weekly Check-Ins", desc: "Regular progress reviews so the plan keeps adapting instead of letting you plateau." },
      { icon: "MessageCircle", title: "Direct Coach Access", desc: "Questions between check-ins? Reach Sophie directly instead of being left to figure things out yourself." },
      { icon: "Video", title: "Form & Technique Support", desc: "Send training videos for feedback so you move better, train harder and get more from every rep." },
      { icon: "TrendingUp", title: "Long-Term Results", desc: "Build habits, confidence and knowledge you can carry with you well beyond the coaching program." },
    ],
  },

  marquee: ["STRENGTH", "DISCIPLINE", "CONFIDENCE", "PERFORMANCE", "CONSISTENCY", "PROGRESS"],

  band: {
    lineOne: "No shortcuts.",
    lineMuted: "Just a plan you'll",
    lineTwo: "actually follow.",
  },

  contact: {
    kicker: "Start Here",
    heading: "READY TO GET STARTED?",
    sub: "Take a few minutes to apply. If we're a good fit, Sophie will reach out personally.",
  },

  pageTitle: "Sophie Herriot Coaching | Online Fitness Coaching",
  metaDescription:
    "Sophie Herriot Coaching offers personalized 1-on-1 online fitness coaching with custom training, realistic nutrition and consistent accountability built around your goals and lifestyle.",
  og: {
    title: "Sophie Herriot Coaching | Online Fitness Coaching",
    description:
      "Personalized 1-on-1 online fitness coaching designed to help you build strength, confidence and sustainable results.",
  },
};

export default coach;
